import './Footer.css';
export var footerCSS = '_1vkfpza0-2-0-1';